import { z } from "zod";
import {
  AS_ON,
  CURRENT_RATIO,
  DE,
  EBITDA,
  EBITDA_MARGIN,
  GROSS_BLOCK,
  PAT,
  PAT_MARGIN,
  ROCE,
  RONW,
  TOTAL_DEBT,
  TURN_OVER,
  YEAR,
} from "./consts";

export const schema = z.object({
  
    [YEAR]: z.string().min(1, "This field is required"),
    [AS_ON]: z.any(),
    [TURN_OVER]: z.string().min(1, "This field is required"),
    [EBITDA]: z.string().min(1, "This field is required"),
    [EBITDA_MARGIN]: z.string().min(1, "This field is required"),
    [PAT]: z.string().min(1, "This field is required"),
    [PAT_MARGIN]: z.string().min(1, "This field is required"),
    [GROSS_BLOCK]: z.string().min(1, "This field is required"),
    [DE]: z.string().min(1, "This field is required"),
    [ROCE]: z.string().min(1, "This field is required"),
    [CURRENT_RATIO]: z.string().min(1, "This field is required"),
    [TOTAL_DEBT]: z.string().min(1, "This field is required"),
    [RONW]: z.string().min(1, "This field is required"),

});

export type formValues = z.infer<typeof schema>;
